import Model from "./base/model";

class SimulationTms extends Model {
  resourceName() {
    return "simulation_tms";
  }

  fields() {
    return {
      company_id: "",
      company_unit_code: "",
      uf: "",
      city: "",
      weight: "",
      cubed_weight: "",
      packing_quantity: "",
      invoice_amount: "",
      simulation: "",
      return_simulation: "",
      company: { jsonApi: "hasOne", type: "companies"},
    };
  }

  async updateRates(id, data) {
    return this.request(
      this.resourceName() + `/rates/${id}`,
      "PATCH",
      {},
      data
    );
  }

}

export default new SimulationTms();
